import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    openRoleSelection: false,
    roles: [],
    selectedRole: null,
    creds: null
};




// ==============================|| Role REDUCER ||============================== //

export const roleSlice = createSlice({
    name: 'role',
    initialState,
    reducers: {
        setCreds: (state, action) => {
            return {
                ...state,
                creds: action?.payload?.creds
            };
        },
        handleRoleSelection: (state, action) => {
            return {
                ...state,
                openRoleSelection: action?.payload
            };
        },
        setRoles: (state, action) => {
            return {
                ...state,
                roles: action?.payload?.roles
            };
        },
        selectRole: (state, action) => {
            console.log(action)
            return {
                ...state,
                selectedRole: action?.payload?.selectedRole
            };
        },



    }
});

export const { setCreds, handleRoleSelection, setRoles, selectRole } = roleSlice.actions;

export default roleSlice.reducer;